import React, { useEffect, useState } from "react";
import { FaEye, FaTimes } from "react-icons/fa";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Search from "../../common/Search";
import Pagination from "../../common/Pagination";
import { formatDate } from "../../Utils/formatters";
import { getStaffActivity } from "../../redux/services/Staff Services/Staff.Services";

const StaffActivity = () => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [staffActivity, setActivityData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  
  // POPUP STATES
  const [showDescriptionPopup, setShowDescriptionPopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const refreshData = useSelector((state) => state.productModal.refreshData);
  const navigate = useNavigate();

  const fetchStaff = async () => {
    try {
      setLoading(true);
      const payload = { page, search, status };

      const response = await getStaffActivity(payload);
      
      if (response?.success) {
        setActivityData(response.data || []);
        setLastPage(response.last_page || 1);
        setTotalRecords(response.total || 0);
      }
    } catch (error) {
      console.error("Failed to fetch staff:", error);
      setActivityData([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= lastPage) {
      setPage(newPage);
    }
  };

  const handleOpenPopup = (item) => {
    setSelectedItem(item);
    setShowDescriptionPopup(true);
  };

  useEffect(() => {
    fetchStaff();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, search, status, refreshData]);

  return (
    <div>
      <div className="d-md-flex d-block align-items-center justify-content-between mt-1 page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-header">
            <div>
              <h3 className="page-title">Activity Staff</h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <span>All Activity List </span>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div className="main_page">
        {(totalRecords > 0 || search) && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
            <Search
              search={search}
              placeholder="Search"
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}

        <div className="st-wrapper-card">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0 text-nowrap">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Date & Time</th>
                  <th>Name</th>
                  <th>Contact Details</th> 
                  <th>Module</th>
                  <th>Action</th>
                  <th>Record ID</th>
                  <th>IP Address</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="8" className="text-center py-5">
                      <div className="spinner-border text-primary"></div>
                    </td>
                  </tr>
                ) : staffActivity.length > 0 ? (
                  staffActivity.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(page - 1) * 100 + index + 1}</td>
                      <td>{formatDate(item.created_at)}</td>
                      
                      {/* Name Column */}
                      <td>
                        <div>{item.performed_by_details?.name || "-"}</div>
                        <small 
                          className="text-muted" 
                          style={{ textTransform: "capitalize", fontSize: "11px" }}
                        >
                          ({item.performed_by || "Unknown"})
                        </small>
                      </td>

                      {/* 👇 Conditional Logic for Email / Mobile 👇 */}
                      <td>
                        {item.performed_by === "vendor" 
                          ? (item.performed_by_details?.mobile || "-") 
                          : (item.performed_by_details?.email || "-")
                        }
                      </td>

                      <td>{item.module || "-"}</td>

                      {/* ACTION BUTTON */}
                      <td>
                        <button
                          className="d-flex align-items-center gap-2"
                          style={{
                            backgroundColor: "rgba(59, 130, 246, 0.15)",
                            color: "#3b82f6",
                            border: "1px solid rgba(59, 130, 246, 0.3)",
                            padding: "6px 12px",
                            borderRadius: "20px",
                            fontSize: "13px",
                            fontWeight: "600",
                            width: "max-content", 
                            cursor: "pointer",
                            transition: "all 0.2s",
                            textTransform: "capitalize"
                          }}
                          onClick={() => handleOpenPopup(item)}
                          title="Click to view full description"
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgba(59, 130, 246, 0.25)"}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "rgba(59, 130, 246, 0.15)"}
                        >
                          {item.action} <FaEye size={14} />
                        </button>
                      </td>

                      <td>{item.record_id}</td>
                      <td>{item.ip_address || "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-5">
                      <h5 className="mb-0">No Data Found</h5>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {lastPage > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={lastPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>

        {/* DESCRIPTION POPUP MODAL */}
        {showDescriptionPopup && selectedItem && (
          <div
            className="modal fade show"
            style={{
              display: "block",
              backgroundColor: "rgba(0,0,0,0.7)",
              zIndex: 1050,
              backdropFilter: "blur(4px)",
            }}
          >
            <div className="modal-dialog modal-dialog-centered modal-md">
              <div 
                className="modal-content" 
                style={{ 
                  backgroundColor: "#1a1a27", 
                  color: "#ffffff", 
                  border: "1px solid #2b2b40",
                  borderRadius: "12px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.5)"
                }}
              >
                <div className="modal-header" style={{ borderBottom: "1px solid #2b2b40", padding: "15px 20px" }}>
                  <h5 className="modal-title d-flex align-items-center gap-2" style={{ fontSize: "16px" }}>
                     Activity Description
                  </h5>
                  <button
                    type="button"
                    className="btn-close text-light"
                    style={{ background: "transparent", opacity: 0.8 }}
                    onClick={() => setShowDescriptionPopup(false)}
                  >
                    <FaTimes size={18} />
                  </button>
                </div>

                <div className="modal-body" style={{ padding: "20px" }}>
                  <div className="d-flex justify-content-between mb-4 pb-3" style={{ borderBottom: "1px solid #2b2b40" }}>
                    <div>
                      <span className="text-muted d-block" style={{ fontSize: "12px" }}>
                        Performed By (<span style={{ textTransform: "capitalize" }}>{selectedItem.performed_by || "User"}</span>)
                      </span>
                      <span style={{ fontSize: "14px", fontWeight: "500" }}>
                        {selectedItem.performed_by_details?.name || "-"}
                      </span>
                    </div>
                    <div className="text-end">
                      <span className="text-muted d-block" style={{ fontSize: "12px" }}>Module / Action</span>
                      <span style={{ fontSize: "14px", fontWeight: "500", textTransform: "capitalize" }}>
                        {selectedItem.module} <span className="text-primary">({selectedItem.action})</span>
                      </span>
                    </div>
                  </div>

                  <div>
                    <p className="text-muted mb-2" style={{ fontSize: "13px" }}>Details:</p>
                    <div
                      className="p-3 rounded"
                      style={{
                        backgroundColor: "rgba(255,255,255,0.03)",
                        borderLeft: "4px solid #3b82f6",
                        whiteSpace: "pre-wrap",
                        fontSize: "14px",
                        color: "#e2e8f0",
                        lineHeight: "1.6"
                      }}
                    >
                      {selectedItem.description || "No description available."}
                    </div>
                  </div>
                </div>

                <div className="modal-footer" style={{ borderTop: "1px solid #2b2b40", padding: "15px 20px" }}>
                  <button
                    className="btn btn-secondary"
                    style={{ backgroundColor: "#d63c3c", border: "none" }}
                    onClick={() => setShowDescriptionPopup(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StaffActivity;